<template>
    <v-card class="pa-4" flat>
        <v-layout wrap column>
            <v-flex>
                <v-btn @click="$router.push({name:'audience-list'})" flat>
                    <v-icon left small>
                        chevron_left
                    </v-icon>
                    <span class="text-capitalize">Back</span>
                </v-btn>
            </v-flex>
<!--            <v-flex>-->
<!--                <v-layout justify-space-between>-->
<!--                    <v-flex>-->
<!--                        <span class="title font-weight-medium">-->
<!--                            Analysis Name : <span style="color:#1AB177;">{{analysisName}}</span>-->
<!--                        </span>-->
<!--                    </v-flex>-->
<!--                    <v-divider style="margin: 0 25px;" vertical inset></v-divider>-->
<!--                    <v-flex>-->
<!--                        <span class="title font-weight-medium">-->
<!--                            Date Range : {{`${fromDateRange} to ${toDateRange}`}}-->
<!--                        </span>-->
<!--                    </v-flex>-->
<!--                </v-layout>-->
<!--            </v-flex>-->
            <v-flex xs12>
                <div style="position: relative;">
                    <div class="report-hidden-bar" :style="{top: `${height - 40}px`}" style="height: 40px;"></div>
                    <iframe
                            allowfullscreen="false"
                            frameborder="0"
                            :height="height"
                            :src="audienceUrl"
                            width="100%"
                    ></iframe>
                </div>

            </v-flex>
        </v-layout>

    </v-card>
</template>

<script>
    import {mapState} from 'vuex';
	export default {
		name: "AudienceAnalysis",
        props:['monitor_uuid'],
        computed:{
			...mapState('audience',[
				'analysisName',
                'toDateRange',
                'fromDateRange',
                'audienceUrl',
                'width',
                'height'
            ])
        },

	}
</script>

<style scoped>
    .report-hidden-bar {
        position: absolute;
        width: 100%;
        height: 30px;
        background-color: #fff;
    }
</style>
